import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

function Login() {
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  const selectedUser = JSON.parse(localStorage.getItem("selectedUser"));

  useEffect(() => {
    if (!selectedUser) {
      navigate("/");
      return;
    }

    const fetchUser = async () => {
      try {
        const ref = doc(db, "users", selectedUser.id);
        const snapshot = await getDoc(ref);

        if (snapshot.exists()) {
          setUserData({ id: snapshot.id, ...snapshot.data() });
        } else {
          console.error("Користувача не знайдено у Firestore!");
          navigate("/");
        }
      } catch (err) {
        console.error("Помилка при отриманні користувача:", err);
        navigate("/");
      }
    };

    fetchUser();
  }, [navigate, selectedUser]);

  const handleDigit = (digit) => {
    if (input.length < 4) {
      setInput((prev) => prev + digit);
    }
  };

  const handleDelete = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  useEffect(() => {
    if (input.length === 4 && userData) {
      if (input === userData.pin) {
        localStorage.setItem("selectedUser", JSON.stringify(userData));
        navigate(userData.type === "child" ? "/child" : "/parent");
      } else {
        setError(true);
        setTimeout(() => {
          setInput("");
          setError(false);
        }, 1000);
      }
    }
  }, [input, userData, navigate]);

  if (!userData) return <p>Завантаження...</p>;

  return (
    <div className="login-screen">
      <h2>{userData.name}, введи свій PIN-код</h2>

      <div className={`pin-dots ${error ? "shake" : ""}`}>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`dot ${input.length > i ? "filled" : ""}`}
          ></div>
        ))}
      </div>

      <div className="numpad">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, "←", 0].map((key, index) => (
          <button
            key={index}
            className="digit-btn"
            onClick={() =>
              key === "←" ? handleDelete() : handleDigit(String(key))
            }
          >
            {key}
          </button>
        ))}
      </div>

      <button className="back-btn" onClick={() => navigate("/")}>
        Назад
      </button>
    </div>
  );
}

export default Login;
